<style scoped>
.answer_box span {
    margin-right: 10px;
}
</style>
<template>
    <span v-if="answer.length==0">请点击选项图选择答案</span>
    <div class="answer_box" v-else>
        <span v-for="(item,index) in answer" :key="index">{{item+1}}</span>
        &nbsp;&nbsp;
        <Button @click="clearAnswer" type="error" size="small">清空</Button>
    </div>
</template>

<script>
export default {
    props: ["answer"],
    methods: {
        clearAnswer() {
            this.$emit("clearAnswer", "");
        }
    }
};
</script>